import { TableCollapsable, TablePagination } from '@octano/global-ui';
import { useTexts } from '../hooks/useTexts';
import { useColumns } from '../hooks/useColumns';
import { useFormatData } from '../hooks/useFormatData';
import { AttendanceListResponse } from '../types';
import DisplayInfo from '../../../../components/info/DisplayInfo';
import { useAttendancesTableFetch } from './AttendancesTableLoader';
import { CourseDetail } from './CourseDetail';

type Props = {
  data: AttendanceListResponse;
  teacherId: number;
};

export function AttendancesTable({ data, teacherId }: Props) {
  const { query, updateQuery } = useAttendancesTableFetch();
  const texts = useTexts();
  const formatedData = useFormatData(data.data);
  const columns = useColumns();
  return (
    <>
      <TableCollapsable
        noResultsText={
          <DisplayInfo
            insideCard
            title={texts.infoAndError.noIrregularitiesInfo.title}
            textBody={texts.infoAndError.noIrregularitiesInfo.title}
          />
        }
        columns={columns}
        data={formatedData}
        secondColumn={{
          columnName: 'detail',
          headerText: '',
          cellFormat: ({ row }) => (
            <CourseDetail row={row} teacherId={teacherId} />
          ),
        }}
      />
      <TablePagination
        pagination={{
          itemsPerPage: 10,
          currentPage: query.currentPage + 1,
          totalItems: data.total,
          totalPages: data.total_pages,
          onChangePage: (page) =>
            updateQuery({ ...query, currentPage: page - 1 }),
        }}
      />
    </>
  );
}
